import environment from '@environments/environment';

export const GRID_VIEW_URL = `${environment.irisApi}/grid-views/`;
